import React from 'react';

const ErrorScreen: React.FC = (): React.ReactElement => {
  return (
    <section>
      Error Screen
    </section>
  );
}

export default ErrorScreen;
